<template>
    <div class="vue-advanced-search row">
        <div class="search-block-wrapper col-12">
            <div class="pl-3 pr-3 pb-3">
                <search-block
                    @input="handleSearchBlockInput"
                    @alive="handleSearchBlockAlive"
                    :language-id="languageId"
                    :selected-category-id="selectedCategoryId"
                    :selected-region-id="selectedRegionId"
                    :search-page-url="searchPageUrl"
                ></search-block>
            </div>
        </div>
        <div class="mobile-toggle col-12 pb-3">
            <button v-on:click="displayView('maps')" class="btn-secondary mr-3" v-bind:class="{ active: isMaps }">
                {{ mapDisplayTxt }}
            </button>
            <button v-on:click="displayView('list')" class="btn-secondary" v-bind:class="{ active: isList }">
                {{ listDisplayTxt }}
            </button>
        </div>
        <div class="search-results-wrapper col-md-6 col-12" v-if="displayType == 'list' || ifDesktop">
            <div class="pl-3">
                <button class="btn btn-secondary mr-2 mb-2"
                        v-for="filter in results.categories"
                        v-bind:class="{ active : filter.id === selectedFilter}"
                        :key="filter.id"
                        @click.prevent="filterClick(filter.id)">{{ filter.name }}</button>

                <search-results :results="results"
                                :selected-region="selectedRegion"
                                :selected-category="selectedCategory"
                                :selected-filter="selectedFilter"
                                :loading="loading"
                                @pan-to-map-location="handleLocationClicked"
                                :language-id="languageId"
                                :search-page-url="searchPageUrl"
                ></search-results>
            </div>
        </div>

        <div class="google-maps-wrapper col-md-6 col-12" v-if="displayType == 'maps' || ifDesktop">
            <div class="sticky-top">
                <GmapMap
                    style="width: 100%; height: 95vh"
                    :center="center"
                    ref="mapRef"
                    :zoom="mapZoom"
                    map-type-id="roadmap"
                    :options="mapOptions"
                >

                    <gmap-custom-marker
                        v-for="(location, index) in results.locations"
                        :marker="location.location"
                        :key="index"
                        class="gmap-custom-marker"
                    >
                        <marker-wrapper
                            :marker="location"
                            @marker-clicked="handleMarkerClicked"
                        ></marker-wrapper>
                    </gmap-custom-marker>

                    <gmap-info-window
                        :options="infoWindow.options"
                        :position="infoWindow.position"
                        :opened="infoWindow.open"
                        @closeclick="infoWindow.open=false">
                        <div v-html="infoWindow.template"></div>
                    </gmap-info-window>

                </GmapMap>
            </div>
        </div>
    </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import SearchBlock from "./SearchBlock";
import SearchResults from "./SearchResults";
import MarkerWrapper from "./MarkerWrapper";

export default {
    name: "AdvancedSearchContainer",

    props: {
        selectedCategoryId: {
            type: String
        },
        selectedRegionId: {
            type: Number,
            default: 0
        },
        languageId: {
            type: String,
            default: 'nl'
        },
        searchPageUrl: {
            type: String
        }
    },
    components: {
        GmapCustomMarker,
        SearchResults,
        MarkerWrapper,
        SearchBlock,
    },
    data() {
        return {
            mapDisplayTxt: window.Drupal.t('Display on map'),
            listDisplayTxt: window.Drupal.t('Display as a list'),
            loading: true,
            displayType: 'maps',
            ifMobile: (window.outerWidth < 768),
            ifDesktop: (window.outerWidth > 768),
            infoWindow: {
                options: {
                    maxWidth: 300,
                    pixelOffset: {width: 0, height: -35}
                },
                position: {lat: 0, lng: 0},
                open: false,
                template: ''
            },
            results: [],

            selectedCategory: {},
            selectedRegion: {},
            selectedFilter: {},

            categories: [],
            regions: [],

            activeMarker: {},

            center: {lat: 51.2644500, lng: 5.8672814},

            mapZoom: 10,
            mapOptions: {
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                styles: [
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [
                            {"visibility": "off"}
                        ]
                    }
                ]
            }
        }
    },

    mounted() {
        this.loadResults(this.selectedCategoryId, this.selectedRegionId);
    },
    computed: {
        isMaps() {
            return (this.displayType == 'maps');
        },
        isList() {
            return (this.displayType == 'list');
        }
    },
    methods: {
        displayView: function (type) {
            this.displayType = type;
        },
        loadResults(categoryId, regionId) {
            axios.get(`/${this.languageId}/api/advanced-search`, {
                    params: {
                        categoryId: categoryId,
                        regionId: regionId,
                    }
            }).then(response => (
                this.results = response.data
            )).finally(() => {
                this.loading = false;

                if (regionId > 0) {
                    this.mapZoom = this.selectedRegion.zoom;
                    this.panToLocation(this.selectedRegion.location.lat, this.selectedRegion.location.lng);
                }
            });
        },
        filterClick(filterId) {
            this.selectedFilter = filterId;
            axios.get(`/${this.languageId}/api/advanced-search`, {
                  params: {
                    categoryId: this.selectedCategoryId,
                    regionId: this.selectedRegionId,
                    filteredId: filterId
                  }

            }).then(response => (
                this.results.locations = response.data.locations
            )).finally(() => {
                this.loading = false;

                if (this.selectedRegionId > 0) {
                  this.mapZoom = this.selectedRegion.zoom;
                  this.panToLocation(this.selectedRegion.location.lat, this.selectedRegion.location.lng);
                }
            });
        },
        handleLocationClicked(payload) {
            this.mapZoom = 17;
            this.panToLocation(payload.lat, payload.lng);
        },
        handleMarkerClicked(payload) {
            this.mapZoom = 17;
            this.panToLocation(payload.location.lat, payload.location.lng);

            this.infoWindow.position = {lat: payload.location.lat, lng: payload.location.lng}
            this.infoWindow.template = `<div class="maps-card"><h3>${payload.name}</h3><p><strong>${payload.category}</strong> - ${payload.description}</p><a class="cta-link" href="${payload.url}">Lees meer</a></div>`
            this.infoWindow.open = true
        },
        handleSearchBlockInput(payload) {
            this.selectedCategory = payload.category;

            if (payload.region === null) {
                this.selectedRegion = {
                    'code': 0,
                    'label': window.Drupal.t('The whole region'),
                }
            } else {
                this.selectedRegion = payload.region;
            }

            if (this.selectedRegion.code > 0) {
                this.panToLocation(payload.region.location.lat, payload.region.location.lng);
            } else {
                this.mapZoom = 11;
                this.panToLocation(this.center.lat, this.center.lng);
            }

            this.selectedCategoryId = this.selectedCategory.code;
            this.selectedRegionId = this.selectedRegion.code;

            this.loadResults(this.selectedCategory.code, this.selectedRegion.code);
        },
        handleSearchBlockAlive(payload) {
            this.selectedCategory = payload.form.category;
            this.selectedRegion = payload.form.region;

            this.categories = payload.categories;
            this.regions = payload.regions;
        },
        panToLocation(lat, lng) {
            this.$refs.mapRef.panTo({lat: parseFloat(lat), lng: parseFloat(lng)})
        }
    },
}
</script>
